// extracted by mini-css-extract-plugin
module.exports = {"languageDisclaimer":"LanguageDisclaimer_languageDisclaimer__FsATo"};